import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { columnsEnfermero, columnsMedicoNutriFono, columnsOtrosProfesionales } from '../constants/columns';
import { removeColumnByField } from '../../../helpers/tools';
import { JustificacionesModal } from '../components/JustificacionesModal';

export const useGetColumns = ({ filters, handleSearch }) => {
    const navigate = useNavigate();

    const handleClickRow = (row, readOnlyParam) => {
        const [fechaDesde, fechaHasta] = (row?.fechaAsignacion || '').split(' - ');
        const auxDataState = { ...row, idFiguraProfesional: row?.idFiguraProfesional, idFrecuencia: row?.idFrecuencia, idTipoProfesional: filters?.idTipoProfesional, mes: filters.mes, anio: filters.anio, fechaDesde, fechaHasta, readOnly: readOnlyParam };

        const route = "/controlVisitas/detalle";

        if (!!route)
            navigate(route, { state: { ...auxDataState } });
    }

    const actionColumn = {
        headerName: '',
        field: 'action',
        width: 35,
        minWidth: 35,
        maxWidth: 35,
        noPadding: true,
        renderCell: (cellProps) => {
            const { row } = cellProps;
            return (<>
                <PopoverModal>
                    <div className='popover-modal-content'>
                        <div aria-hidden='true' onClick={() => handleClickRow(row, true)} className='item-option clickable-option'>
                            <VisibilityIcon className='edit-icon' />
                            <span className='toggle-action'>Ver</span>
                        </div>
                        {!!row?.puedeGestionar && <JustificacionesModal
                            idEvaluacion={row.idEvaluacion}
                            idProfesional={row.idProfesional}
                            visitasAJustificar={row.visitasAJustificar}
                            handleSearch={handleSearch}
                        />}
                    </div>
                </PopoverModal>
            </>)
        }
    };

    const getColumnsByProfesional = (idTipoProfesional) => {
        if (idTipoProfesional === 2) // Enfermero
            return columnsEnfermero;
        else if ([1, 3, 4].includes(idTipoProfesional)) // Médico, Nutricionista, Fonoaudiólogo
            return columnsMedicoNutriFono;
        else // Otros Profesionales
            return columnsOtrosProfesionales;
    }

    const getColumnsByEstado = (idTipoProfesional, estado) => {
        const columnsByProfesional = getColumnsByProfesional(idTipoProfesional);
        if (estado === -1) // Todos
            return columnsByProfesional;
        else // Cumplidas o Incumplidas
            return removeColumnByField(columnsByProfesional, 'cumplio');
    }

    const initialColumns = useMemo(() => {
        const baseColumns = getColumnsByEstado(filters.idTipoProfesional, filters.estado);
        return [actionColumn, ...baseColumns];
    }, [filters]);

    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [filters]);

    return columns;
}